<template>
  <div class="page">
    <div class="header">Settings</div>
    <div class="account-card-container gap-[24px]">
      <AccountInfoCard
        class="account-card"
        data-test="account-info-card"
      />
      <PaymentMethodsCard
        class="account-card"
        data-test="payment-methods-card"
      />
      <PreferencesCard
        class="account-card"
        data-test="preferences-card"
      />
      <AccountOptionsCard
        class="account-card"
        data-test="account-options-card"
      />
    </div>
  </div>
</template>
<script setup>
import AccountInfoCard from './components/AccountInfoCard.vue';
import PreferencesCard from './components/PreferencesCard.vue';
import AccountOptionsCard from './components/AccountOptionsCard.vue';
import PaymentMethodsCard from './components/PaymentMethodsCard.vue';
import { useDonorStore } from '@/stores/DonorStore.js';
const donorStore = useDonorStore();
</script>
<style lang="scss">
.error-message {
  color: red;
}

.field {
  color: #000;
  text-align: left;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.card-info {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
</style>
